var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.item.commutingIncident)?_c('div',[_vm._v(_vm._s(_vm.$t("incidentReports.yes")))]):_c('div',[_vm._v(_vm._s(_vm.$t("incidentReports.no")))])])
}
var staticRenderFns = []

export { render, staticRenderFns }